<template>
  <div class='investor' v-if='investorPage'>
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
    <input type="file" id='photo' @change='loadAboutPreview' hidden ref="loadPreviewButton"/>

    <div class='page-header-wrapper' v-bind:style="headerStyle">
      <div class='page-header translucent-wrapper'>
        <div class='switch-wrapper'>
          <b-switch v-model="pageObject.isHidden" @change="pageChanged">Скрыть страницу</b-switch>
        </div>

        <div class='switch-wrapper'>
          <b-switch v-model="pageObject.isInvestorPage" @change="pageChanged">Страница инвестора (иначе эмитента)</b-switch>
        </div>

        <div class="centered">
          <span class="button-wrapper" @click="handleLoadPhoto">
            <a class='button is-info'>+</a> Загрузить фото
          </span>
        </div>

        <b-field class='p-option'>
          <b-input placeholder='Заголовок' v-model='pageObject.title'
            @change="handleUpdatePage"
          ></b-input>
        </b-field>

        <b-field class='p-option'>
          <b-input placeholder="Текст" type="textarea" v-model="pageObject.description"
            @change="handleUpdatePage"
          ></b-input>
        </b-field>
      </div>
    </div>

    <h2 class="has-text-centered">Описание</h2>
    <div class="investment-description page-header-wrapper" v-bind:style="descriptionStyle">
      <div class="description-wrapper translucent-wrapper">
        <div class="centered">
          <span class="button-wrapper" @click="handleLoadAboutPreview">
            <a class="button is-info">+</a>Загрузить превью для видео
          </span>
        </div>

        <b-field>
          <b-input placeholder="Текст" v-model="pageObject.aboutTitle" class="p-option"></b-input>
        </b-field>

        <b-field>
          <Editor v-model="aboutDescription" :editorToolbar="customToolbar"
            v-bind:id="'aboutDescriptionEditor'" class="p-option color-black"
          />
        </b-field>

        <b-field>
          <b-input placeholder="Ссылка на видео" v-model="pageObject.aboutVideoUrl"
            class="p-option"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div>
      <h2 class="has-text-centered">Для кого</h2>

      <div class="gray-wrapper">
        <b-field>
          <b-input placeholder="Заголовок" v-model="pageObject.potentialusersTitle"
            class="p-option"
          ></b-input>
        </b-field>

        <div class="advantages">
          <PotentialUser v-for="user in pageObject.potentialUsers" :key="user.id"
            :potentialUser="user"
          />

          <div class="centered"
            v-if="pageObject.potentialUsers"
          >
            <span class="button-wrapper" @click="handleAddPotentialUser">
              <a class="button is-info">+</a>Добавить блок
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h2 class="has-text-centered">Особенности</h2>

      <div class="gray-wrapper">
        <b-field>
          <b-input placeholder="Заголовок" v-model="pageObject.advantagesTitle"
            class="p-option"
          ></b-input>
        </b-field>

        <div class="advantages">
          <AdvantageOrReason v-for="advantage in pageObject.advantages" :key="advantage.id"
            :instance="advantage" :deleteFunc='deleteInvestorPageAdvantage'
            :updateFunc='updateInvestorPageAdvantage' :useEditor='false'
          />

          <div class="centered"
            v-if="pageObject.advantages && pageObject.advantages.length < 6"
          >
            <span class="button-wrapper" @click="handleAddAdvantage">
              <a class="button is-info">+</a>Добавить блок
            </span>
          </div>
        </div>
      </div>
    </div>

    <h2 class="has-text-centered">Тарифные планы</h2>
    <div class='gray-wrapper rates-block'>
      <b-field class='p-option'>
        <b-input placeholder="Заголовок блока тарифных планов" v-model="pageObject.ratesTitle"
          @change="handleUpdatePage"
        ></b-input>
      </b-field>

      <b-field>
        <Editor v-model="ratesDescription" :editorToolbar="customToolbar"
          v-bind:id="'ratesDescriptionEditor'" class="p-option color-black"
        />
      </b-field>

      <b-field class='p-option'>
        <b-input placeholder="Заголовок файла" v-model="pageObject.ratesFileTitle"
          @change="handleUpdatePage"
        ></b-input>
      </b-field>

      <div class='centered'>
        <el-select v-model="selectedDocument" placeholder="Выбрать документ сравнения тарифов"
          @change="changeDocument" class='p-option' clearable
        >
          <el-option
              v-for="document in newDocumentsData"
              :key="[document.path, document.resource_id].join('###')"
              :label="`${document.display_name}`"
              :value="[document.path, document.resource_id].join('###')">
            </el-option>
        </el-select>
      </div>

      <div class='switch-wrapper'>
        <b-switch v-model="pageObject.ratesIsConsultation" @change="pageChanged">
          Показать кнопку консультации
        </b-switch>
      </div>
    </div>

    <h2 class="has-text-centered">Причины выбрать</h2>
    <div class='gray-wrapper'>
      <b-field>
        <b-input placeholder="Заголовок" v-model="pageObject.reasonsTitle" class="p-option">
        </b-input>
      </b-field>

      <div class='advantages'>
        <AdvantageOrReason v-for="reason in pageObject.reasons" :key="reason.id"
          :instance='reason' :deleteFunc='deleteInvestorPageReason'
          :updateFunc='updateInvestorPageReason' :useEditor='true'
        />

        <div class="centered" v-if="pageObject.reasons && pageObject.reasons.length < 5">
          <span class='button-wrapper' @click="handleAddReason">
            <a class='button is-info'>+</a>Добавить блок
          </span>
        </div>
      </div>
    </div>

    <div class="caption">
      <h2>Акция, соответствующая услуге</h2>
      <span>Чтобы добавить акцию перейдите в меню "Акции"</span>
    </div>
    <div class="promo-wrapper is-flex">
      <el-select
        v-model="selectedPromo"
        placeholder="Выбрать акцию"
        @change="changePromo"
        class="p-option"
        clearable
      >
        <el-option
          v-for="promo in servicePromos"
          :key="promo.id"
          :label="promo.title"
          :value="promo.id">
        </el-option>
      </el-select>
    </div>

    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveInvestorPage()" :disabled="disabled">
        {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import deepcopy from 'deepcopy'
  import uuidv4 from 'uuid/v4'
  import router from '../../../router'

  import AdvantageOrReason from './AdvantageOrReason'
  import PotentialUser from './PotentialUser'

  import { VueEditor as Editor } from 'vue2-editor'

  export default {
    name: 'Investor',

    data () {
      return {
        base64photo: '',
        base64preview: '',
        disabled: false,
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
          ['link']
        ],
        aboutDescription: '',
        ratesDescription: '',
        selectedDocument: null,
        selectedPromo: null
      }
    },

    computed: {
      ...mapState(['investorPage', 'documentTypes', 'newDocumentTypes', 'servicePromos']),

      pageObject () {
        this.aboutDescription = this.investorPage.aboutDescription
        this.ratesDescription = this.investorPage.ratesDescription

        if (this.investorPage) {
          if (this.$route.params.id === 'new') {
            router.push({ name: 'Investors' })
          }
          this.base64photo = ''
          this.base64preview = ''

          return deepcopy(this.investorPage)
        } else {
          return { }
        }
      },

      headerStyle () {
        if (this.pageObject.photo || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.investorPage.photo})` }
          }
          return { background: `url(${this.base64photo})` }
        }
        return ''
      },

      descriptionStyle () {
        if (this.pageObject.aboutVideoPreview || this.base64preview) {
          if (!this.base64preview.length) {
            return { background: `url(/upload/photos/${this.investorPage.aboutVideoPreview})` }
          } else {
            return {background: `url(${this.base64preview})`}
          }
        } else {
          return {background: ''}
        }
      },

      documentsData: {
        get () {
          const result = []
          deepcopy(this.documentTypes).forEach(x => result.push(...x.documents))
          return result
        }
      },
      newDocumentsData: {
        get () {
          const result = []
          deepcopy(this.newDocumentTypes).forEach(x => result.push(x))
          return result
        }
      },
    },

    methods: {
      ...mapActions(['saveInvestorPage', 'addInvestorPageAdvantage', 'addInvestorPageReason',
        'addInvestorPagePotentialUser', 'updateInvestorPage', 'deleteInvestorPageAdvantage',
        'updateInvestorPageAdvantage', 'getDocumentsTypes', 'getNewDocumentsTypes', 'deleteInvestorPageReason',
        'updateInvestorPageReason', 'getPromosForServices']),

      handleSaveInvestorPage () {
        this.disabled = true
        this.saveInvestorPage(this.pageObject)
          .then(_ => {
            this.disabled = false
            this.$toast.open({ message: 'Сохранено' })
          })
      },

      changePromo (value) {
        this.pageObject.promo_id = value && value !== '' ? value : null
      },

      handleAddAdvantage () {
        this.addInvestorPageAdvantage({
          id: uuidv4(),
          title: '',
          description: '',
          order: this.pageObject.advantages.length,
          investor_page_id: this.investorPage.id
        })
        this.$forceUpdate()
      },

      handleAddReason () {
        this.addInvestorPageReason({
          id: uuidv4(),
          title: '',
          description: '',
          order: this.pageObject.reasons.length,
          investor_page_id: this.investorPage.id
        })
        this.$forceUpdate()
      },

      handleAddPotentialUser () {
        this.addInvestorPagePotentialUser({
          id: uuidv4(),
          title: '',
          lead: '',
          learnMoreLink: '',
          learnMoreTitle: '',
          order: this.pageObject.potentialUsers.length,
          investor_page_id: this.investorPage.id
        })
        this.$forceUpdate()
      },

      handleLoadPhoto () {
        this.$refs.loadPhotoButton.click()
      },

      handleLoadAboutPreview () {
        this.$refs.loadPreviewButton.click()
      },

      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64photo = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.pageObject.newPhoto = formData
      },

      loadAboutPreview (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64preview = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.pageObject.newAboutPreview = formData
      },

      pageChanged () {
        this.$forceUpdate()
      },

      handleUpdatePage () {
        this.updateInvestorPage(this.investorPage)
      },

      changeDocument (value) {
        this.pageObject.ratesFile = value
      }
    },

    created () {
      this.getNewDocumentsTypes()
      this.getPromosForServices()
    },

    watch: {
      aboutDescription () {
        this.pageObject.aboutDescription = this.aboutDescription
      },
      ratesDescription () {
        this.pageObject.ratesDescription = this.ratesDescription
      },
      investorPage (val) {
        this.selectedDocument = val.ratesFile ? val.ratesFile : null
        this.selectedPromo = val.promo_id ? val.promo_id : null
      }
    },

    components: { AdvantageOrReason, PotentialUser, Editor }
  }
</script>

<style>
.gray-wrapper {
  background: #eeeeee;
}

.rates-block {
  /* margin-top: 50px; */
}

.switch-wrapper {
  margin-top: 20px;
}

.page-header {
  max-width: 100%;
}

.promo-wrapper {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// Investor.vue?073e4e6d